<template>
  <div class="w-100 justify-content-center d-flex flex-flow-column connection-flight-box-wrap">
    <!-- TRANSIT FLIGHT class="card info-flight"-->
    <!-- <CCardBody> -->
      <div class="d-flex justify-content-between w-100 m-auto connectingflight-title" >
        <div >
            {{$t('connectingFlight.flightDetails')}}
        </div>
        <div v-if="flightObject[0].flight.TotalDuration">
            {{$t('connectingFlight.travelDuration')}} 
            {{flightObject[0].flight.TotalDuration | convertToHrMin("minutes","H [h] mm [m]")}}
        </div>
      </div>

    <div :class="isResultPage?'connectingRow w-100':'w-100'" v-for="(flightsObj,pindex) in flightObject" :key="'pIdobagain'+pindex" class="passenger-card-wrap-ex-re">
      <div  class="main-info-wrap flex-flow-column w-100">
          <div class="max-w-620px mt-10px w-100 m-auto">
              <div class="flight-code-name">
                  <div>
                      <div class="d-flex ">
                        <div >
                          <img class=" flight-det-logo"
                                  v-if='airlines && flightsObj && flightsObj.flight.opAirline &&
                       airlines[flightsObj.flight.opAirline].logourl '
                                  :src="airlines[flightsObj.flight.opAirline].logourl || defaultALImg"  height="30px"
                          />
                          <img class=" flight-det-logo" v-else-if="flightsObj.flight.logo_url" :src="flightsObj.flight.logo_url" alt  height="30px"/>
                          <img class=" flight-det-logo" v-else :src="defaultALImg" alt  height="30px"/>
                        </div>
<!--                          <img :src="airlines[flightsObj.flight.opAirline].logourl || defaultALImg" alt="" height="30px">-->
                          <div v-if="flightsObj" class="ml-10px">
                             <span v-if="flightsObj.flight.opAirline && airlines">
                                {{airlines[flightsObj.flight.opAirline].airline_name}}
                               <!-- {{flightsObj.flight.opAirline|airlineName}}  -->
                               
                             </span>
                            <span v-else-if="flightsObj.flight.airline_name">
                               {{flightsObj.flight.airline_name}}</span>     
                              {{flightsObj && flightsObj.flight.FlightNo}}
                          </div>
                      </div>
                  </div>
                  <div>

                                        
                   <div v-if="isResultPage">
               <div v-if="selFlight &&!selFlight.hasOwnProperty('legID') &&  selFlight.selectStatus && selFlight.obFlight
               
               && selFlight.obFlight && selFlight.obFlight[0].flight.Bookingclass" >
                   <div class=""> {{$t('connectingFlight.class')}}
                   <span>{{selFlight.obFlight[0].flight.Bookingclass}} {{selFlight.fareType ? '- '+
                                               selFlight.fareType : null}}</span> </div>
               </div>
               <div v-if="selFlight &&!selFlight.hasOwnProperty('legID') &&  selFlight.selectStatus && selFlight.ibFlight 
               
                && selFlight.ibFlight && selFlight.ibFlight[0].flight.Bookingclass" >
                   <div class=""> {{$t('connectingFlight.class')}}
                   <span>{{selFlight.ibFlight[0].flight.Bookingclass}} {{selFlight.fareType ? '- '+
                                               selFlight.fareType : null}}</span> </div>
               </div>
               <div v-if="selFlight &&  selFlight.hasOwnProperty('legID') 
                && selFlight.obFlight && selFlight.obFlight[0].flight.Bookingclass" >
                
                   <div class=""> {{$t('connectingFlight.class')}}
                   <span>{{selFlight.obFlight[0].flight.Bookingclass}} {{selFlight.fareType ? '- '+
                                               selFlight.fareType : null}}</span> </div>
               </div>
               </div>
               <div v-else-if="!isResultPage">
                 <div v-if="flightClass">
                  <div class="">  {{$t('connectingFlight.class')}}  {{flightClass}}
                 </div>
               </div>
                      </div>
                  </div>
              </div>
              <div class="flight-details-cf">
                  <table>
                      <tbody>
                      <tr>
                          <td>
                              <img src="@imgPath/img/svg/icons/take-off-gray.svg" width="20px">
                          </td>
                          <td>
                              <div v-c-tooltip.hover="{
                      content:`${dateFormatInTooltip(flightsObj.flight.DepDate)}
                       `,}">
                                  {{flightsObj &&
                                  flightsObj.flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                              </div>

                          </td>
                          <td> {{flightsObj && flightsObj.flight.DepDate|
                              formatDate("DD MMM YYYY")}}</td>
                          <td v-if="flightsObj">
                            
                            <span v-if="airlines"> {{flightsObj.flight.DepAirport | cityName}}</span>
                            <span v-else-if="flightsObj.flight.depCity"> {{flightsObj.flight.depCity}}</span>
                               {{
                              flightsObj.flight.DepAirport}}
                          </td>
                          <td v-if="flightsObj &&  flightsObj.flight && flightsObj.flight.baggage" class="d-flex">
                              <img src="@imgPath/img/svg/icons/Suitcase_icon.svg" width="20px" alt="">
                              <div class="ml-10px">
                                  {{flightsObj &&  flightsObj.flight.baggage && flightsObj.flight.baggage[0].weightinkg+' Kg'}}
                              </div>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <img src="@imgPath/img/svg/icons/landing-gray.svg" width="20px" alt="">
                          </td>
                          <td>
                              <div v-c-tooltip.hover="{
                    content:`${dateFormatInTooltip(flightsObj.
                    flight.ArrDate)}

                                `,
                            }"
                              >
                                  {{flightsObj &&
                                  flightsObj.flight.ArrDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}

                              </div>
                          </td>
                          <td>{{flightsObj && flightsObj.flight.ArrDate|
                              formatDate("DD MMM YYYY")}}</td>
                          <td v-if="flightsObj">
                            <span v-if="airlines"> {{flightsObj.flight.ArrAirport | cityName}}</span>
                            <span v-else-if="flightsObj.flight.arrCity"> {{flightsObj.flight.arrCity}}</span>
                              {{flightsObj &&
                              flightsObj.flight.ArrAirport}}
                          </td>
                          <td>
                             <div class="ml-auto">
                               {{$t('connectingFlight.Duration')}} {{flightsObj.flight.DurationInMin | convertToHrMin("minutes","H [h] mm [m]")}} 

                                 <!-- Duration {{flightsObj &&
                                 flightsObj.flight.ArrDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT) &&
                                 flightsObj.flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)
                                 }} hours -->
                             </div>
                          </td>
                      </tr>
                      </tbody>
                  </table>
                    <div class="transit-title-blue" v-if="pindex <= 0"> <span>
<!--                        <div>Transit Duration 1h 55m in heho</div>-->
                        <div v-if='flightsObj.transit && flightsObj.transit.transittime!="" && flightsObj.transit.transittime!=null'>

                          {{$t('connectingFlight.transitDuration',{dur:flightsObj.transit.transittime | convertToHrMin("minutes","H [h] mm [m]"),
                          place:flightsObj.flight.ArrAirport | cityName})}}
                      </div>
                    </span> </div>
                  <!-- <div>

                      <div v-if='flightsObj.transit && flightsObj.transit.transittime!="" && flightsObj.transit.transittime!=null'>

                          {{$t('connectingFlight.transitDuration',{dur:flightsObj.transit.transittime | convertToHrMin("minutes","H [h] mm [m]"),
                          place:flightsObj.flight.ArrAirport | cityName})}}
                      </div>
                  </div> -->

              </div>
          </div>
<!--        <div class="info-wrap">-->

<!--          <div class="flight-name">-->
<!--            <div v-if="flightsObj" class="logo">-->
<!--              &lt;!&ndash; <img-->
<!--                                :src="$options.filters.ALimage(flightsObj && flightsObj.flight.opAirline)"-->
<!--                                :onerror="defaultALImg"-->
<!--              />&ndash;&gt;-->
<!--              <img-->
<!--                v-if='airlines && flightsObj && flightsObj.flight.opAirline &&-->
<!--                       airlines[flightsObj.flight.opAirline].logourl '-->
<!--                :src="airlines[flightsObj.flight.opAirline].logourl || defaultALImg"-->
<!--              />-->
<!--              <img v-else :src="defaultALImg" alt width="20px"/>-->
<!--              &lt;!&ndash; <div class="logo" v-else><img :src="defaultALImg">-->
<!--                                                        </div> &ndash;&gt;-->
<!--            </div>-->

<!--            <div class="name">-->
<!--              <div class="t-flight-name">-->
<!--                {{flightsObj &&-->
<!--                flightsObj.flight.opAirline|airlineName}}-->
<!--              </div>-->
<!--              <span class="flight-code">{{flightsObj && flightsObj.flight.FlightNo}}</span>-->
<!--              &lt;!&ndash; <span class="flight-code">-->
<!--                {{flightsObj && flightsObj.flight.DepDate|-->
<!--                  formatDate(DATE_TIME_FORMAT.DAY_DATE_MONTH)}}-->
<!--              </span> &ndash;&gt;-->
<!--            </div>-->
<!--          </div>-->

<!--&lt;!&ndash;          <div class="time-place-wrap">&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="left">&ndash;&gt;-->
<!--&lt;!&ndash;              <div&ndash;&gt;-->
<!--&lt;!&ndash;                class="time"&ndash;&gt;-->
<!--&lt;!&ndash;                v-c-tooltip.hover="{&ndash;&gt;-->
<!--&lt;!&ndash;                      content:`${dateFormatInTooltip(flightsObj.flight.DepDate)}&ndash;&gt;-->
<!--&lt;!&ndash;                       `,}"&ndash;&gt;-->
<!--&lt;!&ndash;              >&ndash;&gt;-->
<!--&lt;!&ndash;                {{flightsObj &&&ndash;&gt;-->
<!--&lt;!&ndash;                flightsObj.flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="place-code">&ndash;&gt;-->
<!--&lt;!&ndash;                {{flightsObj &&&ndash;&gt;-->
<!--&lt;!&ndash;                flightsObj &&&ndash;&gt;-->
<!--&lt;!&ndash;                flightsObj.flight.DepAirport}}&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="place">&ndash;&gt;-->
<!--&lt;!&ndash;                {{flightsObj &&&ndash;&gt;-->
<!--&lt;!&ndash;                flightsObj.flight.DepAirport | cityName}}&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;              <span class="place">&ndash;&gt;-->
<!--&lt;!&ndash;                {{flightsObj && flightsObj.flight.DepDate|&ndash;&gt;-->
<!--&lt;!&ndash;                formatDate("ddd, DD MMM ")}}&ndash;&gt;-->
<!--&lt;!&ndash;              </span>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="center">&ndash;&gt;-->
<!--&lt;!&ndash;              <span>&ndash;&gt;-->
<!--&lt;!&ndash;                {{flightsObj && flightsObj.flight.DurationInMin|&ndash;&gt;-->
<!--&lt;!&ndash;                convertToHrMin("minutes","H [h] mm [m]")}}&ndash;&gt;-->
<!--&lt;!&ndash;              </span>&ndash;&gt;-->
<!--&lt;!&ndash;              <img src="@imgPath/img/svg/icons/flying-flight.svg" alt />&ndash;&gt;-->

<!--&lt;!&ndash;              &lt;!&ndash; <span v-if="isStopsForNonMyanmar" class="stop">&ndash;&gt;-->
<!--&lt;!&ndash;                {{$t('flightResults.nonstop')}}&ndash;&gt;-->
<!--&lt;!&ndash;                &ndash;&gt;-->
<!--&lt;!&ndash;              </span> &ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              <span&ndash;&gt;-->
<!--&lt;!&ndash;                v-if="flightsObj.flight.via!=null"&ndash;&gt;-->
<!--&lt;!&ndash;                class="via"&ndash;&gt;-->
<!--&lt;!&ndash;              >{{flightsObj.flight.via.text && flightsObj.flight.via.text }}</span>&ndash;&gt;-->
<!--&lt;!&ndash;              &ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->

<!--&lt;!&ndash;            <div class="right">&ndash;&gt;-->
<!--&lt;!&ndash;              <div&ndash;&gt;-->
<!--&lt;!&ndash;                class="time"&ndash;&gt;-->
<!--&lt;!&ndash;                v-c-tooltip.hover="{&ndash;&gt;-->
<!--&lt;!&ndash;                    content:`${dateFormatInTooltip(flightsObj.&ndash;&gt;-->
<!--&lt;!&ndash;                    flight.ArrDate)}&ndash;&gt;-->

<!--&lt;!&ndash;                                `,&ndash;&gt;-->
<!--&lt;!&ndash;                            }"&ndash;&gt;-->
<!--&lt;!&ndash;              >&ndash;&gt;-->
<!--&lt;!&ndash;                {{flightsObj &&&ndash;&gt;-->
<!--&lt;!&ndash;                flightsObj.flight.ArrDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}&ndash;&gt;-->
<!--&lt;!&ndash;                &lt;!&ndash; <span&ndash;&gt;-->
<!--&lt;!&ndash;                  class="day"&ndash;&gt;-->
<!--&lt;!&ndash;                  v-c-tooltip.hover="{&ndash;&gt;-->
<!--&lt;!&ndash;                              content:`${noOfDaysTooltip(flightsObj.flight.no_of_days)}`,&ndash;&gt;-->
<!--&lt;!&ndash;                            }"&ndash;&gt;-->
<!--&lt;!&ndash;                >{{ flightsObj && flightsObj.flight.no_of_days}}</span> &ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="place-code">&ndash;&gt;-->
<!--&lt;!&ndash;                {{flightsObj &&&ndash;&gt;-->
<!--&lt;!&ndash;                flightsObj.flight.ArrAirport}}&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="place">&ndash;&gt;-->
<!--&lt;!&ndash;                {{flightsObj &&&ndash;&gt;-->
<!--&lt;!&ndash;                flightsObj.flight.ArrAirport | cityName}}&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;              <span class="place">&ndash;&gt;-->
<!--&lt;!&ndash;                {{flightsObj && flightsObj.flight.ArrDate|&ndash;&gt;-->
<!--&lt;!&ndash;                formatDate("ddd, DD MMM ")}}&ndash;&gt;-->
<!--&lt;!&ndash;              </span>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--          <div v-if="flightsObj && flightsObj.flight.baggage" class="luggage d-flex">-->
<!--                    <img src="@imgPath/img/svg/icons/Suitcase_icon.svg" alt/>-->
<!--                    <span>{{flightsObj &&  flightsObj.flight.baggage && flightsObj.flight.baggage[0].weightinkg+' Kg'}}</span>-->
<!--                </div>-->
<!--               <div v-if="isResultPage">-->
<!--                <div v-if="!selectedMLFlight && GET_OB_FLIGHT_OBJ && selectedFlight && GET_OB_FLIGHT_OBJ.pId == selectedFlight.pId -->
<!--                && GET_OB_FLIGHT_OBJ.obFlight && GET_OB_FLIGHT_OBJ.obFlight[0].flight.Bookingclass" >-->
<!--                    Class-->
<!--                    <span>{{GET_OB_FLIGHT_OBJ.obFlight[0].flight.Bookingclass}} {{GET_OB_FLIGHT_OBJ.fareType ? '- '+-->
<!--                                                GET_OB_FLIGHT_OBJ.fareType : null}}</span>-->
<!--                </div>-->
<!--                <div v-if="!selectedMLFlight && GET_IB_FLIGHT_OBJ && selectedFlight && GET_IB_FLIGHT_OBJ.pId == selectedFlight.pId-->
<!--                 && GET_IB_FLIGHT_OBJ.ibFlight && GET_IB_FLIGHT_OBJ.ibFlight[0].flight.Bookingclass" >-->
<!--                    Class-->
<!--                    <span>{{GET_IB_FLIGHT_OBJ.ibFlight[0].flight.Bookingclass}} {{GET_IB_FLIGHT_OBJ.fareType ? '- '+-->
<!--                                                GET_IB_FLIGHT_OBJ.fareType : null}}</span>-->
<!--                </div>-->
<!--                &lt;!&ndash; {{selectedFlight? selectedFlight.obFlight[0].flight.Bookingclass:''}} &ndash;&gt;-->
<!--                <div v-if="selectedMLFlight -->
<!--                 && selectedMLFlight.obFlight && selectedMLFlight.obFlight[0].flight.Bookingclass" >-->
<!--                    Class-->
<!--                    <span>{{selectedMLFlight.obFlight[0].flight.Bookingclass}} {{selectedMLFlight.fareType ? '- '+-->
<!--                                                selectedMLFlight.fareType : null}}</span>-->
<!--                </div>-->
<!--                </div>-->
<!--                <div v-else-if="!isResultPage">-->
<!--                  <div v-if="flightClass">-->
<!--                    Class {{flightClass}}-->
<!--                  </div>-->
<!--                </div>-->
<!--          <div v-if='flightsObj.transit && flightsObj.transit.transittime!="" && flightsObj.transit.transittime!=null'>-->
<!--           Transit Duration {{flightsObj.transit.transittime | convertToHrMin("minutes","H [h] mm [m]")}}-->
<!--             in {{flightsObj &&-->
<!--                flightsObj.flight.ArrAirport | cityName}}-->
<!--          </div>-->
<!--          <br />-->
<!--        </div>-->
      </div>
    </div>

    <!-- </CCardBody> -->
  </div>
</template>

<script>
import BaseConfiguration from "../../config/base.js";
import {
  COMPONENT_NAME,DATE_TIME_FORMAT,
  PATHNAME,
  FLIGHT_SELECTION_STATUS
} from "../../util/constants";
import { mapGetters, mapActions } from "vuex";
import { cloneDeep } from '../../util/util';
export default {
  name: COMPONENT_NAME.C_CONNECTING_FLIGHT_INFO,
  props: {
    flightObject: {
      type: Object | Array
    },
    selectedFlight: {
      type: Object | Array
    },
    flightClass: {
      type: String
    },
    isResultPage: {
      type: Boolean
    }
  },
  data: () => ({
    defaultALImg: BaseConfiguration.defaultALImg,
    isStopsForNonMyanmar: BaseConfiguration.isStopsForNonMyanmar,
    airlines: null,
    selFlight:null,
    index:null,
  }),

  computed: {
          DATE_TIME_FORMAT()
          {
            return DATE_TIME_FORMAT
          },
    ...mapGetters("sResult", {
      GET_AIRLINES: "GET_AIRLINES",
      GET_OB_FLIGHT_OBJ: "GET_OB_FLIGHT_OBJ",
      GET_IB_FLIGHT_OBJ: "GET_IB_FLIGHT_OBJ"
    }),
    ...mapGetters("sMLResult", {
                GET_ML_AIRLINES: "GET_ML_AIRLINES",
                GET_FLIGHT_OBJ: "GET_FLIGHT_OBJ"
            }),
  },
    watch: {
    GET_OB_FLIGHT_OBJ:{
        immediate: false, 
        deep: true,
    handler: function (newVal, oldVal) {
          this.selFlight = this.flightObjForClass(this.selectedFlight)
    }
      
      },
      GET_IB_FLIGHT_OBJ:{
        immediate: false, 
        deep: true,
    handler: function (newVal, oldVal) {
          this.selFlight = this.flightObjForClass(this.selectedFlight)
    }
      
      },
      GET_FLIGHT_OBJ:{
        immediate: false, 
        deep: true,
    handler: function (newVal, oldVal) {
          this.selFlight = this.flightObjForClass(this.selectedFlight)
    } 
      },
  }, 
  created(){
    if(this.GET_AIRLINES){
      this.airlines = this.GET_AIRLINES
    }else{
      this.airlines=this.GET_ML_AIRLINES
    }
    this.selFlight = this.flightObjForClass(this.selectedFlight)
  },
  methods: {

    flightObjForClass(pselectedFlight) {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("flightObjForClass");
          if(pselectedFlight){
          for (let i = 0; i < pselectedFlight.length; i++) {
        if(pselectedFlight[i].selectStatus == 1){
          retValue = pselectedFlight[i]
        }
          }
      }
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_CONNECTING_FLIGHT_INFO,
                  "error in flightObjForClass",
                  err.toString(),
                  "flightObjForClass",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
    }, 
    ///to get no of days tooltip
    noOfDaysTooltip(pNoofDays) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("noOfDaysTooltip");
        if (pNoofDays) {
          if (pNoofDays == 1) {
            retValue = "Flight lands the next day";
          } else {
            pNoofDays = pNoofDays.replace("+", "");
            retValue = "Flight lands after " + pNoofDays + " days";
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_CONNECTING_FLIGHT_INFO,
          "error in noOfDaysTooltip",
          err.toString(),
          "noOfDaysTooltip",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    ///to get date object in particular format

    dateFormatInTooltip(pDate) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("formatDate");
        if (pDate != null) {
          retValue = this.$options.filters.formatDate(
            pDate,
          
            DATE_TIME_FORMAT.DAY_DATE_MONTH
          );
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_CONNECTING_FLIGHT_INFO,
          "error in dateFormatInTooltip",
          err.toString(),
          "dateFormatInTooltip",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    }
  }
};
</script>
<style scoped>
.connectingRow{
  margin-left: 245px;
}
.flight-det-logo{
  /* width: 40px; */
    border-radius: 50%;
    /* vertical-align: middle;
    border-style: none; */
}
</style>